import { LIST_POINT_OF_SALES } from "@/constants/storage-type";
import { MODEL_DESIGNER } from "@/constants/states";
export default {
  listPointOfSale: JSON.parse(localStorage.getItem(LIST_POINT_OF_SALES)) || [],
  model: JSON.parse(JSON.stringify(MODEL_DESIGNER)),
};
